"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PythonInvalidVersionError = exports.getPackageInfo = void 0;
const semver = require("semver");
const common_1 = require("./common");
const PACKAGE_NAME = "Name: ";
const PACKAGE_VERSION = "Version: ";
const PACKAGE_DEPS = "Requires-Dist: ";
const DEP_PARSE_REGEX = /^(?<name>[\w.-]+)(\s?\(?(?<specifier><|<=|!=|==|>=|>|~=|===)(?<version>[\w.]+)\)?)?/;
function getPackageInfo(fileContent) {
    const lines = fileContent.split("\n");
    let name = "";
    let version = "";
    const dependencies = [];
    for (let line of lines) {
        line = line.trim();
        if (line.length === 0) {
            continue;
        }
        if (line.startsWith(PACKAGE_NAME)) {
            name = line.substring(PACKAGE_NAME.length);
        }
        else if (line.startsWith(PACKAGE_VERSION)) {
            version = line.substring(PACKAGE_VERSION.length);
        }
        else if (line.startsWith(PACKAGE_DEPS)) {
            const pythonPackage = parseDependency(line.substring(PACKAGE_DEPS.length));
            if (pythonPackage) {
                dependencies.push(pythonPackage);
            }
        }
    }
    const validVersion = semver.coerce(version);
    if (!validVersion) {
        throw new PythonInvalidVersionError(`version ${version} is not compatible with semver and cannot be compared`);
    }
    return {
        name: name.toLowerCase(),
        version: validVersion.toString(),
        dependencies,
    };
}
exports.getPackageInfo = getPackageInfo;
// parse a line containing a dependency package name and (optional) specifier + version
function parseDependency(packageDependency) {
    packageDependency = packageDependency.trim();
    const parsedDep = DEP_PARSE_REGEX.exec(packageDependency);
    if (!(parsedDep === null || parsedDep === void 0 ? void 0 : parsedDep.groups)) {
        return null;
    }
    const { name, version, specifier } = parsedDep.groups;
    const correctedSpecifier = (0, common_1.specifierValidRange)(specifier, version);
    return {
        name: name.toLowerCase(),
        version,
        specifier: correctedSpecifier,
    };
}
class PythonInvalidVersionError extends Error {
}
exports.PythonInvalidVersionError = PythonInvalidVersionError;
//# sourceMappingURL=metadata-parser.js.map